import { Link } from "gatsby"
import { convertSlugToCategoryName, getCategorySlug } from "libs/utils/dom"
import React from "react"
import styled from "styled-components"
import { IconDot } from "styleguide/icons"
import { uiColorToBaseColor } from "styleguide/styles/colors"

interface Props {
  categories: string[]
  date: string
  author: string
}

const MetaContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  svg {
    width: 3px;
    height: 3px;
    margin: 0 8px;
  }
`

const Category = styled(Link)`
  font-size: 14px;
  line-height: 24px;
  text-transform: capitalize;
`

const CategoryWrapper = styled.div`
  display: flex;
  align-items: center;
`

const StyledMeta = styled.span`
  line-height: 24px;
  font-size: 14px;
  color: ${uiColorToBaseColor("gray")};
`

const MetaTags = ({ categories, date, author }: Props) => (
  <MetaContainer>
    {categories.map(category => (
      <CategoryWrapper key={category}>
        <Category to={getCategorySlug(category)}>
          {convertSlugToCategoryName(category)}
        </Category>
        <IconDot />
      </CategoryWrapper>
    ))}
    <StyledMeta>{date}</StyledMeta>
    <IconDot />
    <StyledMeta>by {author}</StyledMeta>
  </MetaContainer>
)

export default MetaTags
